import {request, setAuthInHeader} from "@/api/request";

const state = {
    UserInfo: {},
    FlyhighUserInfo: {},
};

const getters = {
    getUserInfo: state => state.UserInfo,
    getFlyhighUserInfo: state => state.FlyhighUserInfo,
    getIsInitFlyhigh: state => state.isInitFlyhigh,
};

const mutations = {
    updateUserInfo(state, obj) {
        state.UserInfo = obj.value;
    },
    resetUserInfo(state) {
        state.UserInfo = {};
    },
    updateFlyHighUserInfo(state, obj) {
        state.FlyhighUserInfo = obj.value;
    },
    resetFlyHighUserInfo(state) {
        state.FlyhighUserInfo = {};
    },
    updateInitFlyHigh(state, obj) {
        state.isInitFlyhigh = obj.value;
    },
};

const actions = {

    setUserInfo({commit, rootState}, {token, mb_no}) {
        setAuthInHeader(token);
        let params = {
            m_type: 'admin',
            no: mb_no,
        }
        request.get('member', params)
            .then((res) => {
                let result = res.data.Data.Result;
                if (result.Info.Type > 0 && result.List.length > 0) {
                    commit('updateUserInfo', {'value': result.List[0]})
                } else {
                    commit('updateUserInfo', {'value': {}})
                }

            }, () => {
                console.log('error');
            })
    },
    changeUserInfo({commit, rootState}, {data}) {
        commit('updateUserInfo', {'value': data});
    },
    initUserInfo({commit, rootState}, {data}) {
        commit('resetUserInfo');
    },
    changeIsInitFlyhigh({commit, rootState}, {value}) {
        commit('updateInitFlyHigh', {value: value})
    },
    setFlyhighUserInfo({commit, rootState}, {token}) {
        setAuthInHeader(token);
        commit('updateInitFlyHigh', {value: 1})
        request.memberGet('member/add/chk/flyhigh').then(res => {
            let memberResult = res.data.Data.Result;
            if(memberResult.Info.type < 0) {
                commit('updateInitFlyHigh', {value: false})
                return false;
            }
            commit('updateInitFlyHigh', {value: true})
            let params = {
                opp:1
            }
            request.get('flyhigh/member', params)
                .then((res) => {
                    let result = res.data.Data.Result;
                    if (result.Info.type > 0 && result.List.length > 0) {
                        commit('updateFlyHighUserInfo', {'value': result.List[0]})
                        let langList = language.state.languageList
                        let langIndex = langList.findIndex(lang => lang.c_idx === result.List[0].c_idx);
                        if (langIndex > -1) {
                            let langName = langList[langIndex].c_location.toLowerCase();
                            Vue.$localStorage.set('lang', langName);
                            EventBus.$emit('langeChange');
                        }
                    } else {
                        commit('updateUserInfo', {'value': {}})
                    }

                }, () => {
                    console.log('error');
                })
        })
    },
    changeFlyhighUserInfo({commit, rootState}, {data}) {
        commit('updateFlyHighUserInfo', {'value': data});
    },
    initFlyhighUserInfo({commit, rootState}, {data}) {
        commit('resetFlyHighUserInfo');
    },
};


export default {namespaced: true, state, getters, mutations, actions}
